










import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryBankCodeList,DeleteBankCode } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import constant from '@/utils/constant'
import { PlatformStatusFormat } from '@/utils/tyepconvert'
import EditBankCodeDialog from './components/EditBankCodeDialog.vue'

@Component({
  components: {
    VQuery,
    VTable,
    EditBankCodeDialog,
  },
})
export default class BankCodeList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [
    { title: '银行编码', param: 'bankCode' },
    { title: '银行名称', param: 'bankName' },
    { title: '汇付支付银行编码', param: 'huifuBankCode' },
    { title: '是否有效', param: 'enableStatus',type:'select',selectData: constant.PlatformStatus },
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [
    { title: '创建银行', type: 'primary', click: this.createHouse },
  ]
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '银行编码', param: 'bankCode' },
    { title: '银行名称', param: 'bankName' },
    { title: '汇付支付银行编码', param: 'huifuBankCode' },
    { title: '连连支付银行编码', param: 'llpayBankCode' },
    // { title: '图标', param: 'bankIcon',type:'image' },
    { title: '是否有效', param: 'enableStatus', formatter: PlatformStatusFormat },
    { title: '创建时间', param: 'createTime', formatter: DateFormat },
    {
      title: '操作',
      width: 150,
      operation: [
        { title: '修改', icon: 'el-icon-edit', click: this.openUpdate},
        { title: '删除', icon: 'el-icon-delete', class: 'red', click: this.deleteRow },
      ],
    },
  ]

  public async created() {
    this.loadData()
  }

  public createHouse() {
    (this.$refs.EditBankCodeDialog as EditBankCodeDialog).open('add')
  }

  public openUpdate(data: any) {
    (this.$refs.EditBankCodeDialog as EditBankCodeDialog).open('update',data.id)
  }

  // 删除单行数据
  public deleteRow(data: any) {
    console.log(data)
    MessageBox.confirm('确定要删除吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await DeleteBankCode({ id: data.id })
      if (ruslt) {
        Message.success('删除成功')
        this.loadData()
      }
    })
  }

  public async loadData() {
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    const result = await QueryBankCodeList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }

  // 删除单行数据
  // public deleteRow(data: any) {
  //   MessageBox.confirm('确定要删除吗？', '提示', {
  //     type: 'warning',
  //   }).then(async () => {
  //     const ruslt = await DeleteActivity({ id: data.id })
  //     if (ruslt) {
  //       Message.success('删除成功')
  //       this.loadData()
  //     }
  //   })
  // }
}
